import {registerOutboxExecutor} from 'src/offline/executorRegistry';
import {registerFileUploadExecutor} from 'src/offline/pendingUploads';
import type {TasksOfflineApi} from './offline/api';
import {bindTasksOfflineApi} from './offline/api';
import {createActionExecutor, transitionTaskExecutor} from './offline/executors';
import {TASK_OUTBOX_KINDS} from './offline/outboxKinds';
import {startTasksCacheScheduler} from './offline/tasksSession';

// Called from the offline composition root, which owns the API client — this
// tier may not import it. Registers the outbox executors and the cache refresher.
export const registerTasksOffline = (api: TasksOfflineApi): void => {
  bindTasksOfflineApi(api);
  registerFileUploadExecutor();
  registerOutboxExecutor(TASK_OUTBOX_KINDS.transition, transitionTaskExecutor);
  // Barrier: the create's inline-attachment uploads must land before it runs.
  registerOutboxExecutor(TASK_OUTBOX_KINDS.create, createActionExecutor, {
    barrier: true,
  });
  startTasksCacheScheduler();
};
